"use strict";

var _core = require("@emotion/core");

var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ThemeProvider = void 0;

var React = __importStar(require("react"));

var core_1 = require("@emotion/core");

var global_styles_1 = require("./global-styles");

function ThemeProvider(props) {
  var theme = props.theme,
      children = props.children;
  return (0, _core.jsx)(core_1.ThemeContext.Provider, {
    value: theme
  }, (0, _core.jsx)(global_styles_1.GlobalStyles, null), children);
}

exports.ThemeProvider = ThemeProvider;